<template>
	<ui-progress
		:stroke="2"
		:value="level"
		mode="determinate"
		type="bar"
	/>
</template>

<script>
import UiProgress from "lib/components/ui/Progress";

// use webkit prefixed fallback for using AudioContext with Safari and older Chrome versions
const AudioContext = window.AudioContext || window.webkitAudioContext || false;

export default {
	name: "VuMeter",
	components: {
		UiProgress
	},
	props: {
		stream: {
			required: true,
			// custom validator since IE11 will crash with type: MediaStream even if component is never mounted
			validator: (prop) => typeof MediaStream === "function" && prop instanceof MediaStream
		}
	},
	data() {
		return {
			level: 0
		};
	},
	watch: {
		stream() {
			this.setup();
		}
	},
	created() {
		this.audioContext = null;
	},
	mounted() {
		this.setup();
	},
	beforeDestroy() {
		if (this.audioContext)
			this.close();
	},
	methods: {
		async setup() {
			if (typeof MediaStream === "undefined" || !(this.stream instanceof MediaStream) || !AudioContext)
				return;

			try {
				if (this.audioContext)
					await this.close(); // close returns promise

				this.audioContext = new AudioContext();

				this.mediaStreamSource = this.audioContext.createMediaStreamSource(this.stream);
				this.processor = this.audioContext.createScriptProcessor(2048, 1, 1);

				this.mediaStreamSource.connect(this.processor);
				this.processor.connect(this.audioContext.destination);

				this.processor.onaudioprocess = (evt) => {
					const inputData = evt.inputBuffer.getChannelData(0);
					const level = Math.round(100 * Math.max(...inputData));

					this.level = Math.max(level, this.level - 5);
				};
			} catch (error) {
				console.log("Failed to create media stream source for audio context", error);
			}
		},
		close() {
			return this.audioContext.close().then(() => {
				// disconnect order reverse of connect order
				if (this.processor) {
					this.processor.disconnect();
					this.processor = null;
				}

				if (this.mediaStreamSource) {
					this.mediaStreamSource.disconnect();
					this.mediaStreamSource = null;
				}

				this.audioContext = null;
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.ui-progress-bar {
	margin: 8px 0;
	// disable transition on md-progress-bar to prevent high CPU usage (renders very frequently)
	/deep/ .md-progress-bar-fill {
		transition: none;
	}
}
</style>
